import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { CircularProgress } from "@mui/material";
import styles from "./DashboardCard.module.css";

const DashboardCard = ({ 
  title, 
  subtitle, 
  columns, 
  rows, 
  loading = false,
  error = null,
  hideHeader = false,
  titleBottomSpace = 0,
  onCellClick
}) => {
  const getRowId = (row) => row.id;

  // Calculate exact height based on rows
  const ROW_HEIGHT = 52;
  const HEADER_HEIGHT = hideHeader ? 0 : 56;
  const calculatedHeight = HEADER_HEIGHT + (rows?.length || 0) * ROW_HEIGHT;

  return (
    <div className={styles.cardContainer}>
      {/* Card Header */}
      <div className={styles.cardHeader}>
        <h3 className={styles.cardTitle}>{title}</h3>
        {subtitle && <p className={styles.cardSubtitle}>{subtitle}</p>}
      </div>
      {titleBottomSpace > 0 && (
        <div style={{ height: titleBottomSpace }} />
      )}

      {/* Card Content - DataGrid */}
      <div className={styles.cardContent}>
        {loading ? (
          <div className={styles.loadingContainer}>
            <CircularProgress size={40} />
          </div>
        ) : error ? (
          <div className={styles.errorContainer}>
            <p className={styles.errorText}>{error}</p>
          </div>
        ) : rows?.length === 0 ? (
          <div className={styles.emptyContainer}>
            <p className={styles.emptyText}>Please select the countries in the Settings menu to view country-related data.</p>
          </div>
        ) : (
          <DataGrid
            rows={rows}
            columns={columns}
            getRowId={getRowId}
            hideFooter
            disableColumnMenu
            disableRowSelectionOnClick
            disableColumnResize
            disableColumnSelector
            className={`${styles.dataGrid} ${hideHeader ? styles.hideHeader : ''}`}
            rowHeight={ROW_HEIGHT}
            columnHeaderHeight={HEADER_HEIGHT}
            onCellClick={(params) => {
              if (typeof onCellClick === 'function') {
                onCellClick(params.row, params.field);
              }
            }}
            sx={{ height: calculatedHeight }}
          />
        )}
      </div>
    </div>
  );
};

export default DashboardCard;
